const responsiveImage = (src) => {
  if (!src.startsWith("https://images.unsplash.com/")) return {};
  return {
    srcSet: [480, 800, 1200].map((width) => {
      const url = new URL(src);
      url.searchParams.set("w", width);
      url.searchParams.set("q", "75");
      url.searchParams.set("auto", "format");
      return `${url.toString()} ${width}w`;
    }).join(", "),
    sizes: "(max-width: 767px) calc(100vw - 104px), (max-width: 1023px) 40vw, 560px",
  };
};

export const LaptopFrame = ({ src, alt, className = "" }) => (
  <div className={`w-full ${className}`}>
    <div className="overflow-hidden rounded-t-xl border border-black/10 bg-[#131313] p-1.5 pb-0 shadow-2xl">
      <div className="flex items-center gap-1.5 px-2 py-1.5">
        <span className="h-2 w-2 rounded-full bg-white/20" />
        <span className="h-2 w-2 rounded-full bg-white/20" />
        <span className="h-2 w-2 rounded-full bg-white/20" />
      </div>
      <img src={src} {...responsiveImage(src)} alt={alt} loading="lazy" decoding="async" width="1200" height="750" className="aspect-[16/10] w-full rounded-t-sm object-cover" />
    </div>
    <div className="mx-auto h-2.5 w-[112%] max-w-none -translate-x-[5.5%] rounded-b-xl bg-[#1f1f1f]" />
  </div>
);

export const PhoneFrame = ({ src, alt, className = "" }) => (
  <div className={`overflow-hidden rounded-[2rem] border-[6px] border-[#131313] bg-[#131313] shadow-2xl ${className}`}>
    <img src={src} {...responsiveImage(src)} sizes="96px" alt={alt} loading="lazy" decoding="async" width="300" height="600" className="aspect-[9/18] w-full rounded-[1.6rem] object-cover" />
  </div>
);
